import React from "react";
import "styles/components/open-return.scss";
import cn from "classnames";

const OpenReturn = () => {
  return (
    <React.Fragment>
      <div className={cn("otrl-jp__divider-line")} />
      <div className="otrl-jp__open-return">
        <h4 className="otrl-jp__open-return__text">Open return</h4>
        <span className="otrl-jp__open-return__subtext">Return within 1 month</span>
      </div>
    </React.Fragment>
  );
};

export default OpenReturn;
